import { connect } from 'react-redux';
import { hasVisaSupport } from 'src/routes/Checkout/store/domains/visa';
import { getCountryToText } from 'src/routes/Checkout/store/selectors/hotel';
import {
  getEndDate,
  getMedicalInsurance,
} from 'src/routes/Checkout/store/selectors/package';
import TouristsFormWarnings from './TouristsFormWarnings';

const mapStateToProps = (state) => ({
  isInsuranceAvailable: getMedicalInsurance(state),
  hasVisa: hasVisaSupport(state),
  toCountry: getCountryToText(state),
  endDate: getEndDate(state),
});

export default connect(mapStateToProps)(TouristsFormWarnings);
